<template>
    <card class="contact-wrapper">
        <el-row :gutter="20">
            <!-- 紧急联系人 -->
            <el-col v-if="type == 1" :span="24">
                <AdminTitle title="紧急联系人" size="20px">
                    <div class="content-col-title">
                        <div class="show-more" @click="showContact">查看更多</div>
                        <el-button type="primary" class="add-more" size="mini" @click="addContact"
                            >新增</el-button
                        >
                    </div>
                </AdminTitle>
                <!-- 审核录入 -->
                <div class="relation-group" v-if="systemRelationList.length">
                    <div class="relation-group-title">
                        <span class="relation-dot dot-system"></span>
                        <span>审核录入</span>
                    </div>
                    <tp-table
                        :showPagination="false"
                        :tableData="systemRelationList"
                        :columns="memberRelationColumns"
                    />
                </div>
                <!-- 用户填报 -->
                <div class="relation-group" v-if="userRelationList.length">
                    <div class="relation-group-title">
                        <span class="relation-dot dot-user"></span>
                        <span>用户填报</span>
                    </div>
                    <tp-table
                        :showPagination="false"
                        :tableData="userRelationList"
                        :columns="memberRelationColumns"
                    />
                </div>
                <!-- 空数据 -->
                <div class="relation-empty" v-if="!orderInfo.memberRelationList || !orderInfo.memberRelationList.length">
                    暂无数据
                </div>
            </el-col>
            <!-- 订单备注 -->
            <el-col v-if="type == 2" :span="24">
                <AdminTitle title="订单备注" size="20px">
                    <div class="content-col-title">
                        <div class="show-more" @click="showRemark">查看更多</div>
                    </div>
                </AdminTitle>
                <tp-table
                    :showPagination="false"
                    :tableData="orderInfo.orderTraceList"
                    :columns="orderTraceColumns"
                />
                <div class="content-col-trace">
                    <el-input
                        class="content-remark-input"
                        v-model="orderTraceContent"
                        size="small"
                    ></el-input>
                    <el-button
                        class="add-new"
                        size="small"
                        @click="saveOrderTraceContent"
                        icon="el-icon-plus"
                        >新增</el-button
                    >
                </div>
            </el-col>
        </el-row>
        <!-- 联系人列表 -->
        <el-dialog title="紧急联系人" :visible.sync="outerVisibleContact" width="75%">
            <!-- 添加联系人 -->
            <div class="contact-remark-table">
                <div class="contact-add">
                    <el-button class="round-button" type="info" size="mini" @click="copyRelation"
                        >复制</el-button
                    >
                    <el-button class="round-button" type="primary" size="mini" @click="addRelation"
                        >添加</el-button
                    >
                </div>
                <tp-table
                    :height="500"
                    :showPagination="false"
                    :tableData="userList"
                    :columns="userColumns"
                />
            </div>
        </el-dialog>
        <el-dialog
            width="450px"
            title="添加、编辑联系人"
            :visible.sync="innerVisibleContact"
            append-to-body
        >
            <el-form ref="formUser" :model="userFormData" label-width="80px">
                <el-form-item label="联系人" prop="relationName" :rules="rules">
                    <el-input
                        style="width: 300px"
                        v-model="userFormData.relationName"
                        size="small"
                        :disabled="editReadonly"
                    ></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="relationMobile" :rules="rules">
                    <el-input
                        style="width: 300px"
                        v-model="userFormData.relationMobile"
                        size="small"
                        :disabled="editReadonly"
                    ></el-input>
                </el-form-item>
                <el-form-item label="关系类型" prop="relationType" :rules="rules">
                    <SelectDict
                        v-model="userFormData.relationType"
                        dictCode="member:relationType"
                        width="300px"
                        :disabled="editReadonly"
                    ></SelectDict>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input
                        style="width: 300px"
                        type="textarea"
                        v-model="userFormData.remark"
                    ></el-input>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button @click="innerVisibleContact = false" size="small">取 消</el-button>
                    <el-button type="primary" @click="saveRelation" size="small">提 交</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog width="450px" title="添加联系人" :visible.sync="addVisibleContact">
            <el-form ref="formUser" :model="userFormData" label-width="80px">
                <el-form-item label="联系人" prop="relationName" :rules="rules">
                    <el-input
                        style="width: 300px"
                        v-model="userFormData.relationName"
                        size="small"
                    ></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="relationMobile" :rules="rules">
                    <el-input
                        style="width: 300px"
                        v-model="userFormData.relationMobile"
                        size="small"
                    ></el-input>
                </el-form-item>
                <el-form-item label="关系类型" prop="relationType" :rules="rules">
                    <SelectDict
                        v-model="userFormData.relationType"
                        dictCode="member:relationType"
                        width="300px"
                    ></SelectDict>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input
                        style="width: 300px"
                        type="textarea"
                        v-model="userFormData.remark"
                    ></el-input>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button @click="addVisibleContact = false" size="small">取 消</el-button>
                    <el-button type="primary" @click="saveRelation" size="small">提 交</el-button>
                </div>
            </el-form>
        </el-dialog>
        <!-- 备注列表 -->
        <el-dialog title="备注列表" :visible.sync="dialogVisibleRemark" width="60%">
            <div class="contact-remark-table">
                <div class="remark-content">
                    <div class="remark-input">
                        <el-input
                            v-model="remarkData.content"
                            size="small"
                            clearable
                            placeholder="请输入"
                        ></el-input>
                    </div>
                    <div class="remark-submit">
                        <el-button type="primary" size="mini" @click="handleAddRemark"
                            >发送</el-button
                        >
                    </div>
                </div>
                <tp-table
                    height="500px"
                    :showPagination="true"
                    :tableData="remarkList"
                    :columns="remarkColumns"
                    :totalNum="remarkTotal"
                    :current-page.sync="currentPageRemark"
                    :pageSize.sync="pageSizeRemark"
                />
            </div>
        </el-dialog>
    </card>
</template>

<script>
import {
    getRemarkListAPI,
    handleAddRemarkAPI,
    getRelationListAPI,
    addRelationAPI,
    editRelationAPI,
    getRelationDetailAPI,
    delRelationAPI,
    riskRelationAPI,
} from './api';
import SelectDict from '@/views/components/select-dict.vue';

function renderVerifyStatusName(h, row) {
    const text = row['verifyStatusName'] || '';
    const verifyStatus = row['verifyStatus'];
    let colorClass = '';
    if (verifyStatus == 1 || text === '认证成功') {
        colorClass = 'verify-status-success';
    } else if (verifyStatus == 2 || text === '认证失败') {
        colorClass = 'verify-status-fail';
    } else if (verifyStatus == 0 || text === '未认证') {
        colorClass = 'verify-status-default';
    }
    return <span class={['verify-status-tag', colorClass]}>{text}</span>;
}

function renderRelationMobile(h, row) {
    const riskAlertList = row['riskAlertList'] || [];
    return (
        <div class="relation-mobile-cell">
            <span class="relation-mobile">{row['relationMobile']}</span>
            {riskAlertList.length > 0 ? (
                <div class="risk-alert-tags">
                    {riskAlertList.map((item, index) => (
                        <span class="tag-ku t1" key={index}>
                            <i class="el-icon-warning"></i>
                            {item}
                        </span>
                    ))}
                </div>
            ) : null}
        </div>
    );
}

// 数据来源：fromType 1-用户填报 2-系统录入（审核录入）
function renderFromType(h, row) {
    const fromType = row['fromType'];
    if (fromType == 1) {
        return <span class="tag-source tag-source-user">用户填报</span>;
    }
    if (fromType == 2) {
        return <span class="tag-source tag-source-system">审核录入</span>;
    }
    return <span>—</span>;
}

const relationMobileColumn = (minWidth = '260') => ({
    label: '电话',
    prop: 'relationMobile',
    minWidth,
    customRender(h, row) {
        return renderRelationMobile(h, row);
    },
});

const verifyStatusColumn = {
    label: '认证状态',
    prop: 'verifyStatusName',
    minWidth: '120',
    customRender(h, row) {
        return renderVerifyStatusName(h, row);
    },
};

const memberRelationColumns = [
    {
        label: '姓名',
        prop: 'relationName',
        minWidth: '120',
        customRender(h, row) {
            return <p>{row['relationName']}</p>;
        },
    },
    relationMobileColumn(),
    {
        label: '关系',
        prop: 'relationTypeName',
        minWidth: '120',
        customRender(h, row) {
            return <div>{row['relationTypeName']}</div>;
        },
    },
    verifyStatusColumn,
    {
        label: '备注',
        prop: 'remark',
        minWidth: '150',
        customRender(h, row) {
            return <p>{row['remark']}</p>;
        },
    },
];

const orderTraceColumns = [
    {
        label: '时间',
        prop: 'createTime',
        width: "200",
        customRender(h, row) {
            return <p>{row['createTime']}</p>;
        },
    },
    {
        label: '审核人',
        prop: 'traceUserName',
        width: "200",
        customRender(h, row) {
            return <p>{row['traceUserName']}</p>;
        },
    },
    {
        label: '备注',
        prop: 'content',
        minWidth: "300",
        customRender(h, row) {
            return <p>{row['content']}</p>;
        },
    },
];

const userColumns = [
    {
        label: 'id',
        prop: 'id',
        minWidth: '90',
        customRender(h, row) {
            return <p>{row['id']}</p>;
        },
    },
    {
        label: '数据来源',
        prop: 'fromType',
        minWidth: '120',
        customRender(h, row) {
            return renderFromType(h, row);
        },
    },
    {
        label: '姓名',
        prop: 'relationName',
        minWidth: '120',
        customRender(h, row) {
            return <p>{row['relationName']}</p>;
        },
    },
    relationMobileColumn('380'),
    {
        label: '关系',
        prop: 'relationTypeName',
        minWidth: '80',
        customRender(h, row) {
            return <div>{row['relationTypeName']}</div>;
        },
    },
    verifyStatusColumn,
    {
        label: '备注',
        prop: 'remark',
        minWidth: '150',
        customRender(h, row) {
            return <p>{row['remark']}</p>;
        },
    },
    {
        label: '操作',
        minWidth: '150',
        customRender(h, row) {
            // fromType 1-用户填报：不允许删除
            const deletable = row['fromType'] != 1;
            return (
                <div>
                    <el-link
                        style={deletable ? 'margin-right:10px;' : ''}
                        underline={false}
                        type="primary"
                        onClick={() => this.editRelation(row['id'])}
                    >
                        编辑
                    </el-link>
                    {deletable && (
                        <el-link
                            underline={false}
                            type="primary"
                            onClick={() => this.delRelation(row['id'])}
                        >
                            删除
                        </el-link>
                    )}
                </div>
            );
        },
    },
];

const remarkColumns = [
    {
        label: '时间',
        prop: 'createTime',
        width: "200",
        customRender(h, row) {
            return <p>{row['createTime']}</p>;
        },
    },
    {
        label: '审核人',
        prop: 'identitraceUsertyNo',
        width: "140",
        customRender(h, row) {
            return <p>{row['traceUser']?.['userName']}</p>;
        },
    },
    {
        label: '备注',
        prop: 'content',
        minWidth: "300",
        customRender(h, row) {
            return <p>{row['content']}</p>;
        },
    },
];

export default {
    name: 'Contact',
    props: ['member', 'orderInfo', 'type'],
    components: { SelectDict },
    data() {
        return {
            rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
            memberRelationColumns,
            orderTraceColumns,
            userColumns,
            remarkColumns,
            // 编辑联系人相关
            outerVisibleContact: false,
            innerVisibleContact: false,
            addVisibleContact: false,
            userFormData: {
                relationName: '',
                relationMobile: '',
                relationType: '',
                remark: '',
            },
            userList: [],
            dialogVisibleRemark: false,
            remarkList: [],
            remarkData: {
                content: '',
                orderNo: this.$route.params.id,
            },
            currentPageRemark: 1,
            pageSizeRemark: 10,
            remarkTotal: 0,
            orderTraceContent: '',
            editReadonly: false,
        };
    },
    provide() {
        return {
            context: this,
        };
    },
    computed: {
        // fromType 1-用户填报
        userRelationList() {
            const list = (this.orderInfo && this.orderInfo.memberRelationList) || [];
            return list.filter((item) => item.fromType == 1);
        },
        // fromType 2-系统录入（审核录入）
        systemRelationList() {
            const list = (this.orderInfo && this.orderInfo.memberRelationList) || [];
            return list.filter((item) => item.fromType == 2);
        },
    },
    watch: {
        currentPageRemark() {
            this.getRemarkList();
        },
        pageSizeRemark() {
            this.getRemarkList();
        },
    },
    mounted() {},

    methods: {
        async getRemarkList() {
            let params = {
                orderNo: this.$route.params.id,
                page: this.currentPageRemark,
                pageSize: this.pageSizeRemark,
            };
            const res = await getRemarkListAPI(params);
            this.remarkList = res.list || [];
            this.remarkTotal = res.total || 0;
        },
        // 查看备注
        showRemark() {
            this.dialogVisibleRemark = true;
            this.remarkData = {
                content: '',
                orderNo: this.$route.params.id,
            };
            this.getRemarkList();
        },
        //  添加备注
        handleAddRemark() {
            handleAddRemarkAPI(this.remarkData).then(() => {
                this.$message.success('发送成功');
                this.getRemarkList();
                this.remarkData.content = '';
                this.$emit('update:flag', true);
                this.$emit('updateDetail');
            });
        },
        saveOrderTraceContent() {
            let param = {
                content: this.orderTraceContent,
                orderNo: this.$route.params.id,
            };
            handleAddRemarkAPI(param).then(() => {
                this.$message.success('保存成功');
                this.orderTraceContent = '';
                this.$emit('update:flag', true);
                this.$emit('updateDetail');
            });
        },
        // 查看联系人
        showContact() {
            this.outerVisibleContact = true;
            this.getRelationList();
        },
        // 联系人列表
        async getRelationList() {
            this.userList = await getRelationListAPI(this.member.id);
        },
        // 打开添加弹窗
        addRelation() {
            this.innerVisibleContact = true;
            this.editReadonly = false;
            this.userFormData = {
                relationName: '',
                relationMobile: '',
                relationType: '',
                remark: '',
                memberId: this.member.id,
            };
        },
        // 添加联系人
        async saveRelation() {
            const { id, relationMobile } = this.userFormData;
            const { riskAlertList } = await riskRelationAPI({ id, relationMobile });
            if (riskAlertList.length == 0) return this.submit();

            this.$confirm('<div>' + riskAlertList.join('<br>') + '</div>', '提示', {
                confirmButtonText: '继续提交',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning',
            })
                .then(() => {
                    this.submit();
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消保存',
                    });
                });
        },
        // 提交
        submit() {
            if (this.userFormData.id) {
                editRelationAPI(this.userFormData).then(() => {
                    this.$message.success('编辑成功');
                    this.innerVisibleContact = false;
                    this.getRelationList();
                    this.$emit('update:flag', true);
                    this.$emit('updateDetail');
                });
            } else {
                addRelationAPI(this.userFormData).then(() => {
                    this.$message.success('添加成功');
                    this.innerVisibleContact = false;
                    this.addVisibleContact = false;
                    this.getRelationList();
                    this.$emit('update:flag', true);
                    this.$emit('updateDetail');
                });
            }
        },
        // 编辑联系人
        editRelation(id) {
            this.innerVisibleContact = true;
            this.editReadonly = false;
            this.getRelationDetail(id);
        },
        addContact() {
            this.addVisibleContact = true;
            this.editReadonly = false;
            this.userFormData = {
                relationName: '',
                relationMobile: '',
                relationType: '',
                remark: '',
                memberId: this.member.id,
            };
        },
        async getRelationDetail(id) {
            this.userFormData = await getRelationDetailAPI(id);
            // fromType 1-用户填报:仅备注可编辑,其余只读
            this.editReadonly = this.userFormData.fromType == 1;
        },
        delRelation(id) {
            this.$confirm('此操作将永久删除该联系人, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    delRelationAPI(id).then(() => {
                        this.getRelationList();
                        this.$emit('update:flag', true);
                        this.$emit('updateDetail');
                        this.$message({
                            type: 'success',
                            message: '删除成功!',
                        });
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                    });
                });
        },
        // 复制
        copyRelation() {
            const { userList } = this;
            let str = '';
            userList.forEach((item) => {
                str =
                    str +
                    item.relationName +
                    '，' +
                    item.relationMobile +
                    '，' +
                    item.relationTypeName +
                    '，' +
                    item.remark +
                    '\n';
            });
            this.$copyText(str).then(
                () => {
                    this.$message.success('复制成功');
                },
                () => {
                    this.$message.error('复制失败');
                }
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.contact-wrapper /deep/ {
    .verify-status-tag {
        display: inline-block;
        padding: 2px 10px;
        border-radius: 12px;
        font-size: 13px;
        line-height: 20px;
    }
    .verify-status-success {
        background-color: #f0f9eb;
        color: #67c23a;
    }
    .verify-status-fail {
        background-color: #fef0f0;
        color: #f56c6c;
    }
    .verify-status-default {
        background-color: #f5f7fa;
        color: #909399;
    }
    .relation-mobile-cell {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        line-height: 1;
        .relation-mobile {
            flex-shrink: 0;
            line-height: 24px;
        }
    }
    .risk-alert-tags {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
        flex: 1;
        min-width: 0;
        max-width: 100%;
    }
    .tag-ku {
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
        min-height: 24px;
        max-width: 100%;
        padding: 4px 12px;
        border-radius: 46px;
        font-size: 12px;
        line-height: 1.4;
        color: #fff;
        white-space: normal;
        word-break: break-word;
        vertical-align: middle;
        box-sizing: border-box;
        .el-icon-warning {
            color: #fff;
            font-size: 14px;
            margin-right: 5px;
            line-height: 1;
        }
    }
    .t1 {
        background-color: #d05252;
    }
    .tag-source {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 24px;
        padding: 2px 12px;
        border-radius: 46px;
        font-size: 12px;
        line-height: 1.4;
        white-space: nowrap;
    }
    .tag-source-user {
        background-color: #E8F2FE;
        color: #3680F5;
    }
    .tag-source-system {
        background-color: #F0E6FF;
        color: #8246DC;
    }
    .tp-table_row {
        height: auto !important;
        line-height: normal !important;
        td {
            vertical-align: top;
            padding-top: 8px;
            padding-bottom: 8px;
        }
        .cell {
            white-space: normal !important;
            overflow: visible !important;
            line-height: normal !important;
        }
    }
    width: 100%;
    border-color: transparent;
    margin-top: 20px;
    border-radius: 16px;
    color: #222222;
    .el-table__header .el-table__cell {
        font-weight: 600;
    }
    .el-dialog__body {
        padding-top: 10px;
    }
    .contact-remark {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        .item {
            background: #fafafa;
            flex: 1;
            border: 1px solid #ebeef5;
            padding: 5px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &:first-child {
                margin-right: 20px;
            }
        }
    }
    .contact-remark-table {
        .tp-table {
            .tp-table_row {
                height: auto !important;
                line-height: normal !important;
                td {
                    vertical-align: top;
                    padding-top: 8px;
                    padding-bottom: 8px;
                }
                .cell {
                    white-space: normal !important;
                    overflow: visible !important;
                    line-height: normal !important;
                }
            }
            .el-table__fixed-right {
                height: 100% !important;
                &::before {
                    display: none;
                }
            }
        }
        .remark-content {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .remark-input {
                flex: 1;
                margin-right: 20px;
            }
        }
        .contact-add {
            text-align: right;
            margin-bottom: 20px;
        }
    }
    .el-dialog__body {
        padding: 40px 30px 80px;
    }
    .content-col-title {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 5px;
    }
    .content-col-trace {
        line-height: 40px;
        padding-top: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .content-remark-input {
            width: 30%;
            margin-right: 20px;
            .el-input__inner {
                border: none;
                background: #f7f8fa;
            }
        }
    }
    .add-more {
        margin-left: 15px;
        border-radius: 15px;
        font-size: 12px;
    }
    .show-more {
        cursor: pointer;
        display: flex;
        align-items: center;
        border-radius: 15px;
        color: #333333;
        padding: 6px 14px;
        font-size: 12px;
        background: #f7f8fa;
    }
    .relation-group {
        margin-top: 16px;
        padding: 16px 20px;
        background: #fff;
        .relation-group-title {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 600;
            color: #222222;
            margin-bottom: 8px;
            .relation-dot {
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 6px;
            }
            .dot-user {
                background-color: #409eff; // 用户填报-蓝
            }
            .dot-system {
                background-color: #7b61ff; // 审核录入-紫
            }
        }
    }
    .relation-empty {
        padding: 20px 0;
        text-align: center;
        font-size: 13px;
        color: #999999;
    }
}
.round-button {
    border-radius: 15px;
}
.add-new {
    background: #409EFF;
    color: #fff;
    border: none;
}
</style>
